"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setGridViewHoverFieldId = exports.toggleTimeMachinePanel = exports.setOrgChartSettingPanelWidth = exports.toggleOrgChartSettingPanel = exports.setOrgChartGridPanel = exports.toggleOrgChartRightPanel = exports.toggleOrgChartGuideStatus = exports.setCalendarSettingPanelWidth = exports.toggleCalendarSettingPanel = exports.setCalendarGridWidth = exports.toggleCalendarGrid = exports.toggleCalendarGuideStatus = exports.setGanttDateUnitType = exports.setGanttSettingPanelWidth = exports.toggleGanttSettingPanel = exports.setGanttGridWidth = exports.toggleGanttGrid = exports.clearActiveRowInfo = exports.setActiveRowInfo = exports.setNewRecordExpectIndex = exports.setSearchResultCursorIndex = exports.setSearchKeyword = exports.refreshSnapshot = exports.changeSyncingStatus = exports.addDatasheet = exports.updateSnapshot = exports.updateDatasheet = exports.resetDatasheet = exports.setDatasheetConnected = exports.setLoadingRecord = exports.updateDatasheetName = exports.setEditStatus = exports.toggleKanbanGroupingSettingVisible = exports.setKanbanGroupingExpand = exports.setGroupingCollapse = exports.clearActiveFieldState = exports.setActiveFieldState = exports.setDragTarget = exports.setHoverRowOfAddRecord = exports.setHoverGroupPath = exports.setHoverRecordId = exports.datasheetErrorCode = exports.fetchDatasheetPackSuccess = exports.fetchForeignDatasheet = exports.fetchDatasheet = exports.fetchDatasheetApi = exports.recordNodeDesc = exports.switchView = exports.receiveDataPack = exports.requestDatasheetPack = void 0;
exports.triggerViewDerivationComputed = exports.deleteViewDerivation = exports.patchViewDerivation = exports.setViewDerivation = exports.resetExportViewId = exports.activeExportViewId = exports.resetOperateViewId = exports.activeOperateViewId = exports.setRobotPanelStatus = exports.setDatasheetComputed = exports.updateDatasheetComputed = exports.setHighlightFieldId = exports.setCloseSyncViewId = void 0;
const config_1 = require("../../../../../../config");
const i18n_1 = require("../../../../../../exports/i18n");
const store_1 = require("../../../../../../exports/store");
const actions_1 = require("../../../../../../exports/store/actions");
const selectors_1 = require("../../../../../../exports/store/selectors");
const immer_1 = __importDefault(require("immer"));
const player_1 = require("../../../../../../modules/shared/player");
const action_constants_1 = require("../../../../../../modules/shared/store/action_constants");
const redux_batched_actions_1 = require("redux-batched-actions");
const utils_1 = require("../../../../../../utils");
const link_consistency_1 = require("../../../../../../utils/link_consistency");
const datasheet_api_1 = require("../../../../api/datasheet_api");
function requestDatasheetPack(datasheetId) {
    return {
        type: action_constants_1.DATAPACK_REQUEST,
        datasheetId,
    };
}
exports.requestDatasheetPack = requestDatasheetPack;
function ensureInnerConsistency(payload, getState) {
    var _a;
    const { snapshot, datasheet } = payload;
    // @su
    // the check of data consistency
    // datasheet is the only object that should be attention
    // if if all the permission of datasheet is ok, no need to check more
    if (!((_a = datasheet.permissions) === null || _a === void 0 ? void 0 : _a.editable)) {
        // when the permission of datasheet is not ok, then check other factors
        const pageParams = getState ? getState().pageParams : {};
        if (!pageParams.mirrorId) {
            return;
        }
        const mirror = (0, selectors_1.getMirror)(getState(), pageParams.mirrorId);
        if ((mirror === null || mirror === void 0 ? void 0 : mirror.sourceInfo.datasheetId) !== snapshot.datasheetId) {
            return;
        }
        // mirror's editable permission can go through the original datasheet's permission
        if (!(mirror === null || mirror === void 0 ? void 0 : mirror.permissions.editable)) {
            return;
        }
    }
    return; //强制取消一致性提醒，来不及找原因了
    const errorInfo = (0, utils_1.checkInnerConsistency)(snapshot);
    if (errorInfo) {
        player_1.Player.doTrigger(player_1.Events.app_error_logger, {
            error: new Error((0, i18n_1.t)(i18n_1.Strings.error_data_consistency_and_check_the_snapshot)),
            metaData: {
                datasheetId: datasheet.id,
                errors: errorInfo,
            },
        });
        player_1.Player.doTrigger(player_1.Events.app_modal_confirm, {
            key: store_1.ModalConfirmKey.FixInnerConsistency,
            metaData: {
                datasheetId: datasheet.id,
                errors: errorInfo,
            },
        });
    }
}
function ensureLinkConsistency(state, loadedForeignDstId) {
    const error = (0, link_consistency_1.checkLinkConsistency)(state, loadedForeignDstId);
    if (!error || !error.errorRecordIds.size) {
        return;
    }
    return; //强制取消一致性提醒，来不及找原因了
    console.log('found link inconsistency', error);
    player_1.Player.doTrigger(player_1.Events.app_error_logger, {
        error: new Error((0, i18n_1.t)(i18n_1.Strings.error_data_consistency_and_check_the_snapshot)),
        metaData: {
            error,
        },
    });
    player_1.Player.doTrigger(player_1.Events.app_modal_confirm, {
        key: store_1.ModalConfirmKey.FixLinkConsistency,
        metaData: {
            error,
        },
    });
}
const getActiveViewFromData = (datasheet, snapshot, getState) => {
    if (datasheet.activeView)
        return datasheet.activeView;
    /**
     * by Aria
     * attention, if params.viewId as activeView,
     * will make errors when read foreignDatasheet and activeView,
     * it will point to current opened table, rather than real related table
     */
    if (getState && getState().pageParams.datasheetId === datasheet.id) {
        return getState().pageParams.viewId;
    }
    return snapshot.meta.views[0].id;
};
const checkSortInto = (snapshot) => {
    return (0, immer_1.default)(snapshot, draft => {
        const views = draft.meta.views;
        for (const v of views) {
            if (Array.isArray(v.sortInfo)) {
                v.sortInfo = {
                    keepSort: true,
                    rules: v.sortInfo,
                };
            }
        }
    });
};
const mergeRecordMap = (snapshot, recordMap) => {
    return (0, immer_1.default)(snapshot, draft => {
        draft.recordMap = Object.assign(Object.assign({}, recordMap), draft.recordMap);
    });
};
function receiveDataPack(payload, options) {
    const { snapshot, datasheet } = payload;
    const { isPartOfData = false, fixConsistency = true, toMergeRecordMap, getState } = options !== null && options !== void 0 ? options : {};
    if (fixConsistency && !isPartOfData) {
        // TODO: move data consistency check  to node layer, and ensure full recover mechanism
        // check data consistency only when data is editable
        ensureInnerConsistency(payload, getState);
    }
    let newSnapshot = checkSortInto(snapshot);
    if (toMergeRecordMap) {
        newSnapshot = mergeRecordMap(snapshot, toMergeRecordMap);
    }
    return {
        type: action_constants_1.DATAPACK_LOADED,
        datasheetId: datasheet.id,
        payload: Object.assign(Object.assign({}, datasheet), { snapshot: newSnapshot, isPartOfData, forceFetch: options === null || options === void 0 ? void 0 : options.forceFetch, activeView: getActiveViewFromData(datasheet, snapshot, getState) }),
    };
}
exports.receiveDataPack = receiveDataPack;
const switchView = (datasheetId, willActivityViewID) => {
    return {
        datasheetId,
        type: action_constants_1.CHANGE_VIEW,
        payload: willActivityViewID,
    };
};
exports.switchView = switchView;
const recordNodeDesc = (datasheetId, desc) => {
    return {
        type: action_constants_1.RECORD_NODE_DESC,
        datasheetId,
        payload: desc,
    };
};
exports.recordNodeDesc = recordNodeDesc;
const fetchDatasheetApi = (datasheetId, shareId, templateId, embedId, recordIds) => {
    let requestMethod = datasheet_api_1.fetchDatasheetPack;
    if (shareId) {
        requestMethod = () => (0, datasheet_api_1.fetchShareDatasheetPack)(shareId, datasheetId);
    }
    if (templateId) {
        requestMethod = datasheet_api_1.fetchTemplateDatasheetPack;
    }
    if (embedId) {
        requestMethod = () => (0, datasheet_api_1.fetchEmbedDatasheetPack)(embedId, datasheetId);
    }
    return requestMethod(datasheetId, recordIds);
};
exports.fetchDatasheetApi = fetchDatasheetApi;
function fetchDatasheet(datasheetId, successCb, overWrite = false, extra, failCb) {
    return (dispatch, getState) => {
        const state = getState();
        const datasheet = (0, selectors_1.getDatasheet)(state, datasheetId);
        const { shareId, templateId, embedId } = state.pageParams;
        const { recordIds } = extra || {};
        const datasheetLoading = (0, selectors_1.getDatasheetLoading)(state, datasheetId);
        if (datasheetLoading) {
            return;
        }
        if (!datasheet || datasheet.isPartOfData || overWrite) {
            dispatch(requestDatasheetPack(datasheetId));
            return (0, exports.fetchDatasheetApi)(datasheetId, shareId, templateId, embedId, recordIds)
                .then(response => {
                if (!response.data.success && state.catalogTree.treeNodesMap[datasheetId]) {
                    dispatch((0, actions_1.deleteNode)({ nodeId: datasheetId, parentId: state.catalogTree.treeNodesMap[datasheetId].parentId }));
                }
                return Promise.resolve({ datasheetId, responseBody: response.data, dispatch, getState });
            })
                .catch(e => {
                dispatch((0, exports.datasheetErrorCode)(datasheetId, config_1.StatusCode.COMMON_ERR));
                throw e;
            })
                .then(props => {
                // recordIds exits means that only part of recordsIds data is needed @boris
                fetchDatasheetPackSuccess(Object.assign(Object.assign({}, props), { isPartOfData: Boolean(recordIds), forceFetch: overWrite }));
                props.responseBody.success ? successCb && successCb() : failCb && failCb();
            });
        }
        successCb && successCb();
        return;
    };
}
exports.fetchDatasheet = fetchDatasheet;
/**
 * in the expanded UI modal that select related records, request this api to get the related table's permission
 * no need to consider templates
 */
function fetchForeignDatasheet(resourceId, foreignDstId, forceFetch, viewId) {
    return (dispatch, getState) => {
        const state = getState();
        const foreignDatasheet = (0, selectors_1.getDatasheet)(state, foreignDstId);
        const { shareId, embedId } = state.pageParams;
        const datasheetLoading = (0, selectors_1.getDatasheetLoading)(state, foreignDstId);
        if (datasheetLoading) {
            return;
        }
        let requestMethod = datasheet_api_1.fetchForeignDatasheetPack;
        if (viewId) {
            requestMethod = () => (0, datasheet_api_1.fetchForeignDatasheetViewPack)(resourceId, foreignDstId, viewId);
        }
        if (shareId) {
            requestMethod = () => (0, datasheet_api_1.fetchShareForeignDatasheetPack)(shareId, resourceId, foreignDstId);
        }
        if (embedId) {
            requestMethod = () => (0, datasheet_api_1.fetchEmbedForeignDatasheetPack)(embedId, resourceId, foreignDstId);
        }
        if (forceFetch || !foreignDatasheet || foreignDatasheet.isPartOfData) {
            dispatch(requestDatasheetPack(foreignDstId));
            return requestMethod(resourceId, foreignDstId)
                .then(response => {
                return Promise.resolve({ datasheetId: foreignDstId, responseBody: response.data, dispatch, getState });
            })
                .catch(e => {
                if (state.catalogTree.treeNodesMap[foreignDstId]) {
                    dispatch((0, actions_1.deleteNode)({ nodeId: foreignDstId, parentId: state.catalogTree.treeNodesMap[foreignDstId].parentId }));
                }
                dispatch((0, exports.datasheetErrorCode)(foreignDstId, config_1.StatusCode.COMMON_ERR));
                throw e;
            })
                .then(props => {
                fetchDatasheetPackSuccess(Object.assign(Object.assign({}, props), { forceFetch }));
                if (props.responseBody.success) {
                    if (!shareId && !embedId && state.pageParams.datasheetId === resourceId) {
                        dispatch((_dispatch, getState) => {
                            ensureLinkConsistency(getState(), foreignDstId);
                        });
                    }
                }
            });
        }
        return;
    };
}
exports.fetchForeignDatasheet = fetchForeignDatasheet;
/*function newRecordMapContainsNewRecords(oldRecordMap: Readonly<IRecordMap>, newRecordMap: IRecordMap): boolean {
  for (const newRecordId in newRecordMap) {
    if (!(newRecordId in oldRecordMap)) {
      return true;
    }
  }
  return false;
}*/
function fetchDatasheetPackSuccess({ datasheetId, responseBody, dispatch, getState, isPartOfData = false, forceFetch }) {
    var _a;
    if (responseBody.success) {
        //forceFetch=true;
        const state = getState();
        const dataPack = responseBody.data;
        const dispatchActions = [];
        if (dataPack.foreignDatasheetMap) {
            Object.keys(dataPack.foreignDatasheetMap).forEach(foreignDstId => {
                const foreignDatasheetPack = dataPack.foreignDatasheetMap[foreignDstId];
                //const dst = getDatasheet(state, foreignDstId);
                //let toMergeRecordMap = undefined;
                // if (dst) {
                //const oldRecordMap = getSnapshot(state, foreignDstId)!.recordMap;
                //const newRecordMap = foreignDatasheetPack.snapshot.recordMap;//记录没新的，但列有咋办
                //if (!newRecordMapContainsNewRecords(oldRecordMap, newRecordMap)) {
                //return;
                //}
                // toMergeRecordMap = oldRecordMap;
                // }
                dispatchActions.push(receiveDataPack(foreignDatasheetPack, { isPartOfData: true, forceFetch: forceFetch })); //列不同，别merge
                //dispatchActions.push(receiveDataPack(foreignDatasheetPack, { isPartOfData: true, toMergeRecordMap }));
                if (foreignDatasheetPack.fieldPermissionMap) {
                    dispatchActions.push((0, actions_1.loadFieldPermissionMap)(foreignDatasheetPack.fieldPermissionMap, foreignDatasheetPack.datasheet.id));
                }
            });
        }
        if (dataPack.datasheet) {
            const dst = (0, selectors_1.getDatasheet)(state, dataPack.datasheet.id);
            if ((dst === null || dst === void 0 ? void 0 : dst.snapshot) && !dst.isPartOfData && !forceFetch) { //拿到了不用，不浪费吗
                return;
            }
            //恢复一下view.rows,rows是为了记录位置，但付出的代价太大了，先放弃这个特性
            if ((_a = dataPack.snapshot) === null || _a === void 0 ? void 0 : _a.meta.views) {
                const view = dataPack.snapshot.meta.views[0];
                const recordMap = dataPack.snapshot.recordMap;
                if (view && view.rows.length <= 0)
                    Object.keys(recordMap).forEach(recordId => { view.rows.push({ recordId: recordId, hidden: false }); });
            }
            dispatchActions.push(receiveDataPack(dataPack, { isPartOfData, forceFetch, getState }));
            if (dataPack.units) {
                // init unityMap, for `member` field use
                const unitMap = {};
                dataPack.units.filter(unit => unit.unitId).forEach(unit => (unitMap[unit.unitId] = unit));
                dispatch((0, actions_1.updateUnitMap)(unitMap));
                // init UserMap, for `CreatedBy`/`LastModifiedBy` field use
                const userMap = {};
                dataPack.units.filter(unit => unit.userId).forEach(user => (userMap[user.userId] = user));
                dispatch((0, actions_1.updateUserMap)(userMap));
            }
        }
        if (dataPack.fieldPermissionMap) {
            dispatch((0, actions_1.loadFieldPermissionMap)(dataPack.fieldPermissionMap, datasheetId));
        }
        dispatch((0, redux_batched_actions_1.batchActions)(dispatchActions));
    }
    else {
        dispatch((0, exports.datasheetErrorCode)(datasheetId, responseBody.code));
    }
}
exports.fetchDatasheetPackSuccess = fetchDatasheetPackSuccess;
const datasheetErrorCode = (datasheetId, code) => {
    return {
        type: action_constants_1.DATASHEET_ERROR_CODE,
        datasheetId,
        payload: code,
    };
};
exports.datasheetErrorCode = datasheetErrorCode;
// set hover(not clicked) state
const setHoverRecordId = (datasheetId, payload) => {
    return {
        type: action_constants_1.SET_HOVER_RECORD_ID,
        datasheetId,
        payload,
    };
};
exports.setHoverRecordId = setHoverRecordId;
const setHoverGroupPath = (datasheetId, payload) => {
    return {
        type: action_constants_1.SET_HOVER_GROUP_PATH,
        datasheetId,
        payload,
    };
};
exports.setHoverGroupPath = setHoverGroupPath;
const setHoverRowOfAddRecord = (datasheetId, payload) => {
    return {
        type: action_constants_1.SET_HOVER_ROW_OF_ADD_RECORD,
        datasheetId,
        payload,
    };
};
exports.setHoverRowOfAddRecord = setHoverRowOfAddRecord;
/**
 *
 * set current operation's row or column (by sky)
 *
 * for rows, operations here only mean unchecked rows, which can drag it directly,
 * if it's multiple rows, the operation data is obtained from recordRanges
 *
 * for columns, similarly, here only save the single column operation, multiple columns data read from fieldRanges
 *
 * @param datasheetId
 * @param payload
 * @returns
 */
const setDragTarget = (datasheetId, payload) => {
    return {
        type: action_constants_1.SET_DRAG_TARGET,
        datasheetId,
        payload,
    };
};
exports.setDragTarget = setDragTarget;
const setActiveFieldState = (datasheetId, payload) => {
    return {
        type: action_constants_1.SET_ACTIVE_FIELD_STATE,
        datasheetId,
        payload,
    };
};
exports.setActiveFieldState = setActiveFieldState;
const clearActiveFieldState = (datasheetId) => {
    return {
        type: action_constants_1.CLEAR_FIELD_INFO,
        datasheetId,
    };
};
exports.clearActiveFieldState = clearActiveFieldState;
const setGroupingCollapse = (datasheetId, payload) => {
    return {
        type: action_constants_1.SET_GROUPING_COLLAPSE,
        datasheetId,
        payload,
    };
};
exports.setGroupingCollapse = setGroupingCollapse;
const setKanbanGroupingExpand = (datasheetId, payload) => {
    return {
        type: action_constants_1.SET_KANBAN_GROUPING_EXPAND,
        datasheetId,
        payload,
    };
};
exports.setKanbanGroupingExpand = setKanbanGroupingExpand;
const toggleKanbanGroupingSettingVisible = (datasheetId, payload) => {
    return {
        type: action_constants_1.TOGGLE_KANBAN_GROUP_SETTING_VISIBLE,
        datasheetId,
        payload,
    };
};
exports.toggleKanbanGroupingSettingVisible = toggleKanbanGroupingSettingVisible;
const setEditStatus = (datasheetId, payload) => {
    return {
        type: action_constants_1.SET_EDIT_STATUS,
        datasheetId,
        payload,
    };
};
exports.setEditStatus = setEditStatus;
const updateDatasheetName = (datasheetId, newName) => {
    return {
        type: action_constants_1.UPDATE_DATASHEET_NAME,
        datasheetId,
        payload: newName,
    };
};
exports.updateDatasheetName = updateDatasheetName;
const setLoadingRecord = (payload, datasheetId) => {
    return {
        type: action_constants_1.SET_LOADING_RECORD,
        datasheetId,
        payload,
    };
};
exports.setLoadingRecord = setLoadingRecord;
const setDatasheetConnected = (datasheetId) => {
    return {
        type: action_constants_1.DATASHEET_CONNECTED,
        datasheetId,
    };
};
exports.setDatasheetConnected = setDatasheetConnected;
const resetDatasheet = (datasheetId) => {
    return {
        type: action_constants_1.RESET_DATASHEET,
        datasheetId,
    };
};
exports.resetDatasheet = resetDatasheet;
const updateDatasheet = (datasheetId, datasheet) => {
    return {
        type: action_constants_1.UPDATE_DATASHEET,
        datasheetId,
        payload: datasheet,
    };
};
exports.updateDatasheet = updateDatasheet;
const updateSnapshot = (datasheetId, snapshot) => {
    return {
        type: action_constants_1.UPDATE_SNAPSHOT,
        datasheetId,
        payload: snapshot,
    };
};
exports.updateSnapshot = updateSnapshot;
const addDatasheet = (datasheetId, datasheetPack) => {
    return {
        type: action_constants_1.ADD_DATASHEET,
        datasheetId,
        payload: datasheetPack,
    };
};
exports.addDatasheet = addDatasheet;
const changeSyncingStatus = (datasheetId, status) => {
    return {
        type: action_constants_1.SET_DATASHEET_SYNCING,
        datasheetId,
        payload: status,
    };
};
exports.changeSyncingStatus = changeSyncingStatus;
const refreshSnapshot = (datasheetId) => {
    return {
        type: action_constants_1.REFRESH_SNAPSHOT,
        datasheetId,
    };
};
exports.refreshSnapshot = refreshSnapshot;
const setSearchKeyword = (datasheetId, keyword) => {
    return {
        type: action_constants_1.SET_SEARCH_KEYWORD,
        datasheetId,
        payload: keyword,
    };
};
exports.setSearchKeyword = setSearchKeyword;
const setSearchResultCursorIndex = (datasheetId, index) => {
    return {
        type: action_constants_1.SET_SEARCH_RESULT_CURSOR_INDEX,
        datasheetId,
        payload: index,
    };
};
exports.setSearchResultCursorIndex = setSearchResultCursorIndex;
const setNewRecordExpectIndex = (datasheetId, index) => {
    return {
        type: action_constants_1.SET_NEW_RECORD_EXPECT_INDEX,
        datasheetId,
        payload: index,
    };
};
exports.setNewRecordExpectIndex = setNewRecordExpectIndex;
const setActiveRowInfo = (datasheetId, rowInfo) => {
    return {
        type: action_constants_1.SET_ACTIVE_ROW_INFO,
        datasheetId,
        payload: rowInfo,
    };
};
exports.setActiveRowInfo = setActiveRowInfo;
const clearActiveRowInfo = (datasheetId) => {
    return {
        type: action_constants_1.CLEAR_ACTIVE_ROW_INFO,
        datasheetId,
    };
};
exports.clearActiveRowInfo = clearActiveRowInfo;
const toggleGanttGrid = (visible, datasheetId) => {
    return {
        type: action_constants_1.TOGGLE_GANTT_GRID,
        payload: visible,
        datasheetId,
    };
};
exports.toggleGanttGrid = toggleGanttGrid;
const setGanttGridWidth = (width, datasheetId) => {
    return {
        type: action_constants_1.SET_GANTT_GRID_WIDTH,
        payload: width,
        datasheetId,
    };
};
exports.setGanttGridWidth = setGanttGridWidth;
const toggleGanttSettingPanel = (visible, datasheetId) => {
    return {
        type: action_constants_1.TOGGLE_GANTT_SETTING_PANEL,
        payload: visible,
        datasheetId,
    };
};
exports.toggleGanttSettingPanel = toggleGanttSettingPanel;
const setGanttSettingPanelWidth = (width, datasheetId) => {
    return {
        type: action_constants_1.SET_GANTT_SETTING_PANEL_WIDTH,
        payload: width,
        datasheetId,
    };
};
exports.setGanttSettingPanelWidth = setGanttSettingPanelWidth;
const setGanttDateUnitType = (unitType, datasheetId) => {
    return {
        type: action_constants_1.SET_GANTT_DATE_UNIT_TYPE,
        payload: unitType,
        datasheetId,
    };
};
exports.setGanttDateUnitType = setGanttDateUnitType;
// Calendar actions
const toggleCalendarGuideStatus = (visible, datasheetId) => {
    return {
        type: action_constants_1.TOGGLE_CALENDAR_GUIDE_STATUS,
        payload: visible,
        datasheetId,
    };
};
exports.toggleCalendarGuideStatus = toggleCalendarGuideStatus;
const toggleCalendarGrid = (visible, datasheetId) => {
    return {
        type: action_constants_1.TOGGLE_CALENDAR_GRID,
        payload: visible,
        datasheetId,
    };
};
exports.toggleCalendarGrid = toggleCalendarGrid;
const setCalendarGridWidth = (width, datasheetId) => {
    return {
        type: action_constants_1.SET_CALENDAR_GRID_WIDTH,
        payload: width,
        datasheetId,
    };
};
exports.setCalendarGridWidth = setCalendarGridWidth;
const toggleCalendarSettingPanel = (visible, datasheetId) => {
    return {
        type: action_constants_1.TOGGLE_CALENDAR_SETTING_PANEL,
        payload: visible,
        datasheetId,
    };
};
exports.toggleCalendarSettingPanel = toggleCalendarSettingPanel;
const setCalendarSettingPanelWidth = (width, datasheetId) => {
    return {
        type: action_constants_1.SET_CALENDAR_SETTING_PANEL_WIDTH,
        payload: width,
        datasheetId,
    };
};
exports.setCalendarSettingPanelWidth = setCalendarSettingPanelWidth;
// OrgChart view actions
const toggleOrgChartGuideStatus = (visible, datasheetId) => {
    return {
        type: action_constants_1.TOGGLE_ORG_CHART_GUIDE_STATUS,
        payload: visible,
        datasheetId,
    };
};
exports.toggleOrgChartGuideStatus = toggleOrgChartGuideStatus;
const toggleOrgChartRightPanel = (visible, datasheetId) => {
    return {
        type: action_constants_1.TOGGLE_ORG_CHART_GRID,
        payload: visible,
        datasheetId,
    };
};
exports.toggleOrgChartRightPanel = toggleOrgChartRightPanel;
const setOrgChartGridPanel = (width, datasheetId) => {
    return {
        type: action_constants_1.SET_ORG_CHART_GRID_WIDTH,
        payload: width,
        datasheetId,
    };
};
exports.setOrgChartGridPanel = setOrgChartGridPanel;
const toggleOrgChartSettingPanel = (visible, datasheetId) => {
    return {
        type: action_constants_1.TOGGLE_ORG_CHART_SETTING_PANEL,
        payload: visible,
        datasheetId,
    };
};
exports.toggleOrgChartSettingPanel = toggleOrgChartSettingPanel;
const setOrgChartSettingPanelWidth = (width, datasheetId) => {
    return {
        type: action_constants_1.SET_ORG_CHART_SETTING_PANEL_WIDTH,
        payload: width,
        datasheetId,
    };
};
exports.setOrgChartSettingPanelWidth = setOrgChartSettingPanelWidth;
const toggleTimeMachinePanel = (datasheetId, visible) => {
    return {
        type: action_constants_1.TOGGLE_TIME_MACHINE_PANEL,
        payload: visible,
        datasheetId,
    };
};
exports.toggleTimeMachinePanel = toggleTimeMachinePanel;
const setGridViewHoverFieldId = (fieldId, datasheetId) => {
    return {
        type: action_constants_1.SET_GRID_VIEW_HOVER_FIELD_ID,
        payload: fieldId,
        datasheetId,
    };
};
exports.setGridViewHoverFieldId = setGridViewHoverFieldId;
const setCloseSyncViewId = (viewId, datasheetId) => {
    return {
        type: action_constants_1.SET_CLOSE_SYNC_VIEW_ID,
        payload: viewId,
        datasheetId,
    };
};
exports.setCloseSyncViewId = setCloseSyncViewId;
const setHighlightFieldId = (fieldId, datasheetId) => {
    return {
        type: action_constants_1.SET_HIGHLIGHT_FIELD_ID,
        payload: fieldId,
        datasheetId,
    };
};
exports.setHighlightFieldId = setHighlightFieldId;
const updateDatasheetComputed = (computed, datasheetId) => {
    return {
        type: action_constants_1.UPDATE_DATASHEET_COMPUTED,
        payload: computed,
        datasheetId,
    };
};
exports.updateDatasheetComputed = updateDatasheetComputed;
const setDatasheetComputed = (computed, datasheetId) => {
    return {
        type: action_constants_1.SET_DATASHEET_COMPUTED,
        payload: computed,
        datasheetId,
    };
};
exports.setDatasheetComputed = setDatasheetComputed;
const setRobotPanelStatus = (status, datasheetId) => {
    return {
        type: action_constants_1.SET_ROBOT_PANEL_STATUS,
        payload: status,
        datasheetId,
    };
};
exports.setRobotPanelStatus = setRobotPanelStatus;
const activeOperateViewId = (viewId, datasheetId) => {
    return {
        type: action_constants_1.ACTIVE_OPERATE_VIEW_ID,
        payload: viewId,
        datasheetId,
    };
};
exports.activeOperateViewId = activeOperateViewId;
const resetOperateViewId = (viewId, datasheetId) => {
    return {
        type: action_constants_1.RESET_OPERATE_VIEW_ID,
        payload: viewId,
        datasheetId,
    };
};
exports.resetOperateViewId = resetOperateViewId;
const activeExportViewId = (viewId, datasheetId) => {
    return {
        type: action_constants_1.ACTIVE_EXPORT_VIEW_ID,
        payload: viewId,
        datasheetId,
    };
};
exports.activeExportViewId = activeExportViewId;
const resetExportViewId = (datasheetId) => {
    return {
        type: action_constants_1.RESET_EXPORT_VIEW_ID,
        datasheetId,
    };
};
exports.resetExportViewId = resetExportViewId;
const setViewDerivation = (datasheetId, payload) => {
    return {
        datasheetId,
        type: action_constants_1.SET_VIEW_DERIVATION,
        payload,
    };
};
exports.setViewDerivation = setViewDerivation;
// As opposed to set, patch means partial update
const patchViewDerivation = (datasheetId, payload) => {
    return {
        datasheetId,
        type: action_constants_1.PATCH_VIEW_DERIVATION,
        payload,
    };
};
exports.patchViewDerivation = patchViewDerivation;
const deleteViewDerivation = (datasheetId, viewId) => {
    return {
        datasheetId,
        type: action_constants_1.DELETE_VIEW_DERIVATION,
        payload: { viewId },
    };
};
exports.deleteViewDerivation = deleteViewDerivation;
const triggerViewDerivationComputed = (datasheetId, viewId) => {
    return {
        datasheetId,
        type: action_constants_1.TRIGGER_VIEW_DERIVATION_COMPUTED,
        payload: { datasheetId, viewId },
    };
};
exports.triggerViewDerivationComputed = triggerViewDerivationComputed;
//# sourceMappingURL=datasheet.js.map